import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';

export type DropDownOption = {
    key: string;
    tabName: string;
    selected: boolean;
}

@customElement('ji-dropdown-element')
export class JobindsatsDropdownElement extends JobindsatsElement(LitElement) {
    static styles = css`
        .dropdown {
            border: none;
            outline-style: solid;
            outline-width: 3px;
            outline-color: var(--main-blue-10);
            width: 100%;
            height: 40px;
            padding-left: 10px;
            appearance: none;
            text-indent: 1px;
            word-break: break-word;
            white-space: normal;
            padding-right: 30px;
            color: black;
            -webkit-appearance: none;
        }
        .active {
            outline-color: var(--main-blue-50);
        }
        p {
            font-size: 12px;
        }
        .inner-addon {
            position: relative;
        }
        .inner-addon .glyphicon {
            position: absolute;
            padding: 10px;
            pointer-events: none;
        }
        .right-addon .glyphicon { 
            right: 0px;
        }
    `;

    @property({
        attribute: 'options',
    })
    options: DropDownOption[] = [];

    @property()
    title = '';

    @property({
        attribute: 'selected-period',    
    })
    selectedPeriod = '';

    @property()
    expanded = false;

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('click', this.outsideClickListener);
        document.addEventListener('keyup', this.escapeListener);
    }

    disconnectedCallback() {
        document.removeEventListener('click', this.outsideClickListener);
        document.removeEventListener('keyup', this.escapeListener);
        super.disconnectedCallback();
    }

    render() {
        return html`
            <p>${this.title}</p>
            <div class="inner-addon right-addon">
                <i class="icon glyphicon glyphicon-menu-${this.expanded ? 'up' : 'down'}"></i>
                <select aria-label="Vælg en mulighed fra menuen" name="dropdown" class="dropdown ${this.expanded ? 'active' : ''}" role="listbox" @change="${(e: any) => this.optionSelected(e.target.value)}"  @click="${(e: any) => this.optionSelected(e.target.value)}"}>
                    ${this.options.map(option => {
                        if (this.selectedPeriod === option.key) {
                            return html`
                                <option size=15 class="tab" role="option" value=${option.key} selected='selected'>${option.tabName}</option>
                            `
                        }
                        else {
                            return html`
                                <option size=15 class="tab" role="option" value=${option.key}>${option.tabName}</option>
                            `
                        }
                    })}
                </select>
            </div>
        `;
    }

    optionSelected(optionKey: string) {
        if (optionKey === this.selectedPeriod) {
             this.expanded = !this.expanded;
        }
        else {
             const optionSelectedEvent = new CustomEvent('option-selected', {
                 detail: {
                     key: optionKey,
                 },
                 composed: true,
                 bubbles: true,
             });
            this.dispatchEvent(optionSelectedEvent);
            this.expanded = false;
        }
       
    }

    outsideClickListener = (e: any) => {
        if (e.composedPath()[0].name !== 'dropdown') {
            this.expanded = false;
        }
    }

    escapeListener = (e: any) => {
        if (e.key === 'Escape') {
            this.expanded = false;
        }
    }
}